<template>
    <div class="card-body">
        <el-form>
            <el-row :gutter="15">
                <el-col :span="6">
                    <el-form-item label="现金优惠">
                        <el-input v-model="$store.state.modal.data.sum_cashCoupon" size="small" :disabled=true></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>
        <el-form>
            <el-row :gutter="20">
                <el-col :span="6">
                    <el-form-item label="金额">
                        <el-input-number :min="0" v-model="balance" size="small"></el-input-number>
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>
        <div slot="footer" class="dialog-footer" align="right">
            <el-button type="primary" size="small" @click="handleAddStudentCashCoupon()"
                       :loading="$parentInfo.studentWallet.dialog_UpdateCashCoupon.button_loading">充 值
            </el-button>
            <el-button type="primary" size="small" @click="handleDelStudentCashCoupon()"
                       :loading="$parentInfo.studentWallet.dialog_UpdateCashCoupon.button_loading">提 现
            </el-button>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Dialog_UpdateCashCoupon",
        data() {
            return {
                balance:0
            };
        },
        created() {
            this.$parentInfo = this.$root.$children[0].$refs['dashboard'].$refs[this.$route.path];
        },
        destroyed(){
            this.balance=0
        },
        methods: {
            handleAddStudentCashCoupon(){
                this.$parentInfo.studentWallet.dialog_UpdateCashCoupon.button_loading=true;
                this.$wApi.send(this.$parentInfo.path, 'storeStudentCashCoupon', {
                    'student_id': this.$parentInfo.student_id,
                    'balance': this.balance
                });
            },
            handleDelStudentCashCoupon(){
                this.$parentInfo.studentWallet.dialog_UpdateCashCoupon.button_loading=true;
                this.$wApi.send(this.$parentInfo.path, 'storeStudentCashCoupon', {
                    'student_id': this.$parentInfo.student_id,
                    'balance': -this.balance
                });
            }
        }
    }
</script>

<style scoped>

</style>